import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface TabNavigationProps {
  activeTab: 'video' | 'image' | 'music' | 'speech' | 'chat';
  onTabChange: (tab: 'video' | 'image' | 'music' | 'speech' | 'chat') => void;
}

export const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center mb-8">
      <div className="bg-muted p-1 rounded-full flex gap-0.5 md:gap-1 flex-wrap justify-center">
        <button
          onClick={() => onTabChange('video')}
          className={cn(
            "px-3 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200",
            activeTab === 'video'
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t("navigation.videoCreator")}
        </button>
        <button
          onClick={() => onTabChange('image')}
          className={cn(
            "px-3 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200",
            activeTab === 'image'
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t("navigation.imageCreator")}
        </button>
        <button
          onClick={() => onTabChange('music')}
          className={cn(
            "px-3 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200",
            activeTab === 'music'
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t("navigation.musicCreator")}
        </button>
        <button
          onClick={() => onTabChange('speech')}
          className={cn(
            "px-3 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200",
            activeTab === 'speech'
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t("navigation.speechCreator", "AI Speech")}
        </button>
        <button
          onClick={() => onTabChange('chat')}
          className={cn(
            "px-3 py-1.5 md:px-6 md:py-2 rounded-full text-xs md:text-sm font-medium transition-all duration-200",
            activeTab === 'chat'
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {t("navigation.textChat")}
        </button>
      </div>
    </div>
  );
};
